export * from './CustomMaterialModule';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/customMaterialModule/index.ts